import { render, staticRenderFns } from "./Routers.vue?vue&type=template&id=7ffadfb6&scoped=true&"
import script from "./Routers.vue?vue&type=script&lang=js&"
export * from "./Routers.vue?vue&type=script&lang=js&"
import style0 from "./Routers.vue?vue&type=style&index=0&id=7ffadfb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffadfb6",
  null
  
)

export default component.exports